<assessment-row title="Pain Rating">
  <p>{{ data.painRating }}</p>
</assessment-row>

<assessment-row title="Pain Scale">
  <p>{{ data.painScale }}</p>
</assessment-row>

<assessment-row title="Pain Location">
  <p>{{ data.painLocation }}</p>
</assessment-row>

<assessment-row title="Pain Quality">
  <p>{{ data.painQuality }}</p>
</assessment-row>

<assessment-row title="Pain Quality Description">
  <p>{{ data.painQualityOther }}</p>
</assessment-row>

@if (patient().isObstetric()) {
@if (data.hasIntrapartumPain) {
<h2>Intrapartum Pain Assessment</h2>
<assessment-row title="Analgesia">
  <p>{{ data.hasAnalgesia | booleanToYesNo }}</p>
</assessment-row>
@if(data.hasAnalgesia) {
<assessment-row title="Epidural">
  <p>{{ data.hasEpiduralPresent | booleanToYesNo }} </p>
</assessment-row>

<assessment-row title="Nitrous Oxide">
  <p>{{ data.nitrousOxide | booleanToYesNo }}</p>
</assessment-row>

<assessment-row title="Opioids">
  <p>{{ data.opioids | booleanToYesNo }}</p>
</assessment-row>

<assessment-row title="Other">
  <p>{{ data.analgesiaOther }} </p>
</assessment-row>
}
}

<h2>Non-Pharmacologic Interventions</h2>
<assessment-row title="Walking?">
  <p>{{ data.isWalking | booleanToYesNo }} </p>
</assessment-row>
<assessment-row title="Position Change">
  <p>{{ data.positionChange }}</p>
</assessment-row>
<assessment-row title="Birthing Ball?">
  <p>{{ data.hasBirthingBall | booleanToYesNo }}</p>
</assessment-row>
<assessment-row title="Warm Bath?">
  <p>{{ data.warmBath }} </p>
</assessment-row>
<assessment-row title="Other">
  <p>{{ data.nonPharmacologicOther }}</p>
</assessment-row>
}